import { createFileRoute } from "@tanstack/react-router"
import { SocialMonitorPage } from "./-SocialMonitorPage"

export const Route = createFileRoute("/prototypes/social-monitor/")({ component: SocialMonitorPage })
